import React, {useState, useEffect} from 'react'
import axios from 'axios'
import {useIntl} from 'react-intl'
import {getUserByToken} from '../../modules/auth/core/_requests'
import Swal from 'sweetalert2'

const API_URL_REAL = process.env.REACT_APP_API_URL

const AktarimPage = (): React.ReactElement | null => {
  const [loading, setLoading] = useState(true)
  const intl = useIntl()
  const [currentUser, setCurrentUser] = useState<any | undefined>(null)
  const [selectedYear, setSelectedYear] = useState('')
  const [selectedTerm, setSelectedTerm] = useState('')
  const [years, setYears] = useState<number[]>([])
  const [preferences, setPreferences] = useState<any[]>([])
  const [selectedPreference, setSelectedPreference] = useState<any | undefined>(null)
  const [isUnauthorized, setIsUnauthorized] = useState<any>(null)

  // Dönem değerlerini tutan nesne
  const termValues: {[key: string]: number} = {
    Güz: 100001,
    Bahar: 100002,
    Yaz: 100003,
  }

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const {data} = await getUserByToken()
        if (data && data.email !== undefined && data.email !== '') {
          setCurrentUser(data)
          if (data.roleName !== 'ADMIN') {
            setIsUnauthorized(true) // Yetki yok
            setLoading(false) // Yüklemeyi durdur
          } else {
            setIsUnauthorized(false)
            setLoading(false)
          }
        }
      } catch (error) {
        console.error('Error fetching user data:', error)
      }
    }

    const fetchYears = async () => {
      try {
        const response = await axios.get(`${API_URL_REAL}/Custom/GetYears`)
        setYears(response.data)
      } catch (error) {
        console.error('Yıllar alınırken hata:', error)
      }
    }

    const fetchPreferences = async () => {
      try {
        const response = await axios.get(
          `${API_URL_REAL}/PreferencePeriod/getAll?page=1&items_per_page=99999`
        )
        setPreferences(response.data.data)
      } catch (error) {
        console.error('Tercihler alınırken hata:', error)
      } finally {
        setLoading(false) // Tüm yükleme işlemleri tamamlandı
      }
    }

    fetchUserData()
    fetchYears()
    fetchPreferences()
  }, [])

  const handleYearChange = (event: any) => {
    setSelectedYear(event.target.value)
  }

  const handleTermChange = (event: any) => {
    setSelectedTerm(event.target.value)
  }

  const handlePreferenceChange = (event: any) => {
    setSelectedPreference(Number(event.target.value))
  }

  const handleSubmit = async () => {
    const termId = termValues[selectedTerm] // Seçilen dönem için ID'yi al
    if (selectedYear && termId && selectedPreference) {
      const url = `${API_URL_REAL}/Custom/Aktarim?PreferencePeriodID=${selectedPreference}&year=${selectedYear}&term=${termId}`

      try {
        const response = await axios.post(url)

        // Yanıtı kontrol et
        if (response.data.status === 'Success') {
          // Başarı durumunda mesaj
          Swal.fire({
            icon: 'success',
            title: 'İşlem Başarılı!',
            text: response.data.message || 'İşleminiz başarıyla tamamlandı.',
          })
        } else if (response.data.status === 'Error') {
          // Başarısız durumunda mesaj
          Swal.fire({
            icon: 'error',
            title: 'Bir Hata Oluştu',
            text: response.data.message || 'Beklenmeyen bir hata oluştu.',
          })
        }
      } catch (error: any) {
        console.error('Hata oluştu:', error)

        // Hata kontrolü
        if (error.response) {
          // Eğer backend'den gelen bir hata varsa, mesajı alıp göster
          Swal.fire({
            icon: 'error',
            title: 'Bir Hata Oluştu',
            text: error.response.data.message || 'Beklenmeyen bir hata oluştu.',
          })
        } else if (error.request) {
          // Eğer request gönderilememişse
          Swal.fire({
            icon: 'error',
            title: 'Sunucuya Bağlanamadı',
            text: 'Sunucuya bağlanırken bir sorun oluştu.',
          })
        } else {
          // Diğer hatalar
          Swal.fire({
            icon: 'error',
            title: 'Bir Hata Oluştu',
            text: error.message || 'Beklenmeyen bir hata oluştu.',
          })
        }
      }
    } else {
      console.error('Gerekli parametreler eksik.')

      // Eksik parametre uyarısı
      Swal.fire({
        icon: 'warning',
        title: 'Eksik Parametreler',
        text: 'Lütfen gerekli tüm parametreleri doldurduğunuzdan emin olun.',
      })
    }
  }

  if (loading && isUnauthorized == null) {
    return <p>Loading...</p> // Yükleniyor durumu
  }

  if (isUnauthorized && isUnauthorized != null) {
    return <p>Bu ekranda işlem yapmaya yetkiniz yok!</p> // Yetki yoksa gösterilecek mesaj
  } else if (!isUnauthorized && isUnauthorized != null) {
    return (
      <div>
        <h1>{intl.formatMessage({id: 'MENU.AKTARIM'})}</h1>
        <br />
        <div className='card mb-3'>
          <div className='card-body'>
            <h5 className='card-title'>Tercih Dönemi:</h5>
            <select
              value={selectedPreference ?? ''}
              onChange={handlePreferenceChange}
              className='form-select'
            >
              <option value='' disabled>
                {intl.formatMessage({id: 'Select'})}
              </option>
              {preferences.map((preference) => (
                <option key={preference.id} value={preference.id}>
                  {preference.name}
                </option>
              ))}
            </select>

            <h5 className='card-title'>{intl.formatMessage({id: 'TransferYear'})}:</h5>
            <select value={selectedYear} onChange={handleYearChange} className='form-select'>
              <option value='' disabled>
                {intl.formatMessage({id: 'Select'})}
              </option>
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>

            <h5 className='card-title'>{intl.formatMessage({id: 'TransferTerm'})}:</h5>
            <select value={selectedTerm} onChange={handleTermChange} className='form-select'>
              <option value='' disabled>
                {intl.formatMessage({id: 'Select'})}
              </option>
              {Object.keys(termValues).map((term) => (
                <option key={term} value={term}>
                  {term}
                </option>
              ))}
            </select>

            <button onClick={handleSubmit} className='btn btn-primary mt-3'>
              {intl.formatMessage({id: 'Submit'})}
            </button>
          </div>
        </div>
      </div>
    )
  } else return <p></p>
}

export default AktarimPage
